import { IContextualMenuItem } from "@fluentui/react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../src/taskpane/components/_v2/redux/storeMain";
import { setContentManagerFilterSectionsReset, setContentManagerSearchFilterType } from "../../../src/taskpane/redux/modules/contentManagerDirectory";
import { LanguageContext } from "../../../utilities/LocalizationModule";
import { toggleReload } from "../../../src/taskpane/redux/modules/reload";

export function useMenuItem_ClearFilter(waitFor: boolean) {
  const languageStrings = React.useContext(LanguageContext);

  const dispatch = useDispatch();

  const filterSections = useSelector((state: RootState) => state.contentManagerDirectory?.filterSections);
  const searchValue = useSelector((state: RootState) => state.contentManagerDirectory?.searchValue);

  const [filterSelected, setFilterSelected] = React.useState(false);

  React.useEffect(() => {
    if (filterSections || (searchValue && !searchValue.value && searchValue.filterType !== "")) {
      setFilterSelected((searchValue && !searchValue.value && searchValue.filterType !== "")
        || (filterSections?.some(section => section.items.some(item => item.selected === true)) || filterSections?.some(x => (x.daysOffset || x.daysOffset === 0))))
    } else {
      setFilterSelected(false);
    }
  }, [filterSections, searchValue]);

  const [menuItem_ClearFilter, setMenuItem_ClearFilter] = React.useState<IContextualMenuItem>();

  React.useEffect(() => {
    if (filterSelected) {
      setMenuItem_ClearFilter(
        {
          key: "clearFilter",
          text: `${languageStrings.ClearFilter}`,
          disabled: waitFor === true,
          iconProps: { iconName: "ClearFilter" },
          onClick: () => {
            dispatch(setContentManagerFilterSectionsReset());
            dispatch(setContentManagerSearchFilterType(""));
            dispatch(toggleReload());
          }
        }
      )
    } else {
      setMenuItem_ClearFilter(null);
    }
  }, [waitFor, filterSelected]);

  return {
    menuItem_ClearFilter
  }
}